import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConfigCheckerComponent} from './config-checker/components/config-checker/config-checker.component';
import {
  ConfigCheckerSettingsComponent
} from './config-checker/components/config-checker-settings/config-checker-settings.component';


const routes: Routes = [
  {
    path: 'download',
    loadChildren: () => import('./pages/download/download.module').then(m => m.DownloadingPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [],
    canActivateChild: [],
  },
  {
    path: 'design/:design',
    loadChildren: () => import('./pages/design/design.module').then( m => m.DesignPageModule),
  },
  {
    path: 'config-checker',
    component: ConfigCheckerComponent,
  },
  {
    path: 'config-checker-settings',
    component: ConfigCheckerSettingsComponent,
  }

];
@NgModule({
    imports: [
        // AppComponent owns the first navigation so configuration loading cannot race
        // Angular's initial URL handling.
        RouterModule.forRoot(routes, {
          relativeLinkResolution: 'legacy',
          initialNavigation: 'disabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
